import * as React from 'react';
import { Table } from 'antd';
class Summary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: null, // 具体要显示的内容
      detail: false,
      tableLikelyData: [],
      tableUnlikelyData: [],
      str: null,
      heatmap: null
    };
  }
  UNSAFE_componentWillMount() {
    console.log('this.props.data', this.props.data);
    if (this.props.data) {
      this.setState({ data: this.props.data }, () => {
        this.findTbleData();
      });
    }
  }

  componentDidUpdate(prevProps) {
    if(prevProps.data !== this.props.data) {
      this.setState({ data: this.props.data }, () => {
        this.findTbleData();
      });
    }
  }

  // 查找table要显示的内容
  findTbleData = () => {
    let data = this.state.data;
    if (!data.content && data.content.length <= 0) {
      return;
    }
    let content = data.content;
    let ele = content.find(v => { return v.label === 'spe_front_ills_ele'; });
    console.log('ele: ', ele);
    if (ele) {
      let str = ele.content.find(v => { return v.label === 'illustration'; });
      if (str && str.content) {
        this.setState({ str: str.content });
      }
    }
    let sep_back_ele = content.find(v => { return v.label === 'sep_back_table_ele'; });
    if (!sep_back_ele) {
      return;
    }
    if (sep_back_ele && sep_back_ele.content && sep_back_ele.content.length > 0) {
      let lp_table = sep_back_ele.content.find(v => { return v.label === 'lp_table' });
      let up_table = sep_back_ele.content.find(v => { return v.label === 'up_table' });
      if (lp_table && lp_table.content && lp_table.content.data && lp_table.content.data.length > 0) {
        let tableLikelyColums = lp_table.content.columns;
        let tableLikelyData = lp_table.content.data.map(v => { return { name: v[0], value: v[1] }; });
        this.setState({ tableLikelyData: tableLikelyData, tableLikelyColums: tableLikelyColums });
      }
      if (up_table && up_table.content && up_table.content.data && up_table.content.data.length > 0) {
        let tableUnlikelyColums = up_table.content.columns;
        let tableUnlikelyData = up_table.content.data.map(v => { return { name: v[0], value: v[1] }; });
        this.setState({ tableUnlikelyData: tableUnlikelyData, tableUnlikelyColums: tableUnlikelyColums });
      }
    }
    let heatmap = content.find(v => { return v.label === 'spe_front_heatmap_ele'; });
    console.log('heatmap: ', heatmap);
    if (heatmap && heatmap.content && heatmap.content.length > 0) {
      let str = heatmap.content.find(v => { return v.label === 'heatmap'; });
      if (str && str.content) {
        this.setState({ heatmap: str.content }, () => {
          console.log('heatmap: ', this.state.heatmap);
        });
      }
    }
  }
  GetColorByPercent = (percent, value) => {
    // console.log('value: ', value);
    // console.log('percent: ', percent);
    const colorsTop = ['#AB0000', '#FF0000', '#FDF200', '#72FF56'];
    const colorsBot = ['#72FF56', '#00FFCA', '#003AFF', '#000097'];
    let returnColor = '#AB0000'
    if (value > 0) {
      if (percent > 0 && percent <= 25) {
        returnColor = colorsTop[0];
      }
      if (percent > 25 && percent <= 50) {
        returnColor = colorsTop[1];
      }
      if (percent > 50 && percent <= 75) {
        returnColor = colorsTop[2];
      }
      if (percent > 75 && percent <= 100) {
        returnColor = colorsTop[3];
      }
    }
    if (value < 0) {
      if (percent >= 0 && percent <= 25) {
        returnColor = colorsBot[0];
      }
      if (percent > 25 && percent <= 50) {
        returnColor = colorsBot[1];
      }
      if (percent > 50 && percent <= 75) {
        returnColor = colorsBot[2];
      }
      if (percent > 75 && percent <= 100) {
        returnColor = colorsBot[3];
      }
    }
    if (value === 0) {
      returnColor = colorsBot[0];
    }
    return returnColor;
  }
  render() {
    let { tableLikelyData, tableUnlikelyData } = this.state;
    // console.log('tableLikelyData: ', tableLikelyData);
    // console.log('tableUnlikelyData: ', tableUnlikelyData);
    const getPoint = () => {
      let heatmap = this.state.heatmap;
      if (!heatmap || !heatmap.pointers | heatmap.pointers.length <= 0) {
        return null;
      }
      let returnList = [];
      let top = Math.abs(heatmap.top_value); // 取绝对值
      let bot = Math.abs(heatmap.bottom_value);
      let total = top + bot;
      // console.log('total: ', total);
      for (let index = 0; index < heatmap.pointers.length; index++) {
        // 最多2个点
        if (index > 1) {
          break;
        }
        const element = heatmap.pointers[index];
        let pointVlaue = Math.abs(element.value); // 取绝对值
        // console.log('点的值: ', pointVlaue);
        let persent = Number((pointVlaue / total).toFixed(2));
        let color = this.GetColorByPercent(persent * 100, element.value);
        color = '20px solid ' + color;
        // 转化为css单位 rem 4rem为总高度 2个点则为2rem
        // console.log('点的persent: ', persent);
        if (!persent || persent === 0) {
          persent = 2;
        } else {
          persent = 2 * persent;
        }
        // persent = 2 * persent;
        if (element.value === 0) {
          // console.log('persent: ', persent);
          if (index === 1) {
            persent = 0;
          }
          returnList.push(
            <div style={{ height: '2rem' }} key={index}>
              <div className="img-t" style={{ marginTop: persent + 'rem' }}>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <div className="img-tt" style={{ borderRight: color }}></div>
                  <div className="img-text">{element.label_disp}</div>
                </div>
              </div>
            </div >
          );
        }
        if (element.value > 0) {
          // console.log('persent: ', persent);
          returnList.push(
            <div style={{ height: '2rem' }} key={index}>
              <div className="img-t" style={{ marginTop: persent + 'rem' }}>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <div className="img-tt" style={{ borderRight: color }}></div>
                  <div className="img-text">{element.label_disp}</div>
                </div>
              </div>
            </div >
          );
        }
        if (element.value < 0) {
          // persent = Math.abs(persent) + 2;
          // console.log('persent: ', persent);
          returnList.push(
            <div style={{ height: '2rem' }} key={index}>
              <div className="img-b" style={{ marginTop: persent + 'rem' }}>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <div className="img-bb" style={{ borderRight: color }}></div>
                  <div className="b-txt">{element.label_disp}</div>
                </div>
              </div>
            </div >
          );
        }
      }
      return returnList;
    };
    return (
      <React.Fragment>
        {
          this.state.data &&
          <React.Fragment>
            {
              !this.state.detail &&
              <div className="content">
                <div className="title">{this.state.data.label_disp}</div>
                <div className="cnt">
                  <React.Fragment>
                    <div className="show-detail" onClick={() => { this.setState({ detail: true }); }}>查看详情</div>
                    {/* <img src="/img/result-detail-ex3.png" alt="" /> */}
                    {
                      this.state.heatmap &&
                      <div className="iws-bj">
                        <div className="bj-box">
                          <div className="text" style={{ lineHeight: '0.29rem', height: 'auto', width: '5rem' }}>
                            {this.state.heatmap.top_label}
                          </div>
                        </div>
                        <div className="iws-box">
                          <div className="box-numb">
                            <div className="numb-text">{this.state.heatmap.top_value}</div>
                            <div className="numb-text">{this.state.heatmap.middle_value}</div>
                            <div className="numb-text">{this.state.heatmap.bottom_value}</div>
                          </div>
                          <div className="box-t"></div>
                          <div className="box-img">
                            {getPoint()}
                            {/* <div style={{ height: '2rem' }}>
                              <div className="img-t" style={{ marginTop: '0rem' }}>
                                <div>
                                  <div className="img-tt" style={{ borderRight: '20px solid #be0707' }}></div>
                                </div>
                              </div>
                            </div> */}
                            {/* <div style={{ height: '2rem' }}>
                              <div className="img-b" style={{ marginTop: '2rem' }}>
                                <div>
                                  <div className="img-bb" style={{ borderRight: '20px solid #be0707' }}></div>
                                </div>
                              </div>
                            </div> */}
                          </div>
                        </div>
                        <div className="bj-box">
                          <div className="text" style={{ lineHeight: '0.29rem', height: 'auto' }}>
                            {this.state.heatmap.bottom_label}
                          </div>
                        </div>
                      </div>
                    }

                    {/* <p>不同知识类别与基因的关联程度大不相同，同一个基因在有些类别中更显著富集，而在其他类别中则可能反而被“排斥”，这种关系被定量描述后，就可以用来评价信号通路的富集可能，因此，一组基因对应独特的一组定量刻画与该类别之间关系的特征值，当与Pathway Signature比较时，则可以进一步评估哪些信号通路被富集（Likely）或排斥（Unlikely）。</p> */}
                    <p>{this.state.str}</p>
                  </React.Fragment>
                </div>
              </div>
            }
            {
              this.state.detail &&
              <div className="content">
                <div className="back" onClick={() => { this.setState({ detail: false }); }}></div>
                <div className="cnt">
                  <div className="table">
                    <Table
                      bordered={false}
                      scroll={{ y: '2.7rem' }}
                      columns={[
                        {
                          title: this.state.tableLikelyColums[0],
                          key: 'name',
                          dataIndex: 'name',
                          // align: 'center',
                          width: '80%',
                          render: (text) => {
                            return <div style={{ textAlign: 'left' }}>{text}</div>
                          }
                        },
                        {
                          title: this.state.tableLikelyColums[1],
                          key: 'value',
                          dataIndex: 'value',
                          // align: 'center',
                          width: '20%'
                        },
                      ]}
                      rowKey={(record, index) => index.toString()}
                      dataSource={tableLikelyData}
                      pagination={false}
                    />
                  </div>
                  <div className="table">
                    <Table
                      bordered={false}
                      scroll={{ y: '2.7rem' }}
                      columns={[
                        {
                          title: this.state.tableUnlikelyColums[0],
                          key: 'name',
                          dataIndex: 'name',
                          // align: 'center',
                          width: '80%',
                          render: (text) => {
                            return <div style={{ textAlign: 'left' }}>{text}</div>
                          }
                        },
                        {
                          title: this.state.tableUnlikelyColums[1],
                          key: 'value',
                          dataIndex: 'value',
                          // align: 'center',
                          width: '20%'
                        },
                      ]}
                      rowKey={(record, index) => index.toString()}
                      dataSource={tableUnlikelyData}
                      pagination={false}
                    />
                  </div>
                </div>
              </div>
            }
          </React.Fragment>
        }
      </React.Fragment>
    );
  }
}

export default Summary;